import { Icon } from '../../icons';

export default function Alert({ type = "info", children, onClose }) {
  const cfg = {
    info:    { bg: "bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800/50",       text: "text-blue-800 dark:text-blue-200",    icon: "info",  ic: "text-blue-500"    },
    warn:    { bg: "bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800/50",   text: "text-amber-800 dark:text-amber-200",   icon: "alert", ic: "text-amber-500"   },
    danger:  { bg: "bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800/50",         text: "text-red-800 dark:text-red-200",     icon: "alert", ic: "text-red-500"     },
    success: { bg: "bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-800/50", text: "text-emerald-800 dark:text-emerald-200", icon: "check", ic: "text-emerald-500" },
  };
  const c = cfg[type] || cfg.info;
  return (
    <div className={`flex items-start gap-3 p-3.5 rounded-xl border ${c.bg} mb-3`}>
      <Icon name={c.icon} size={15} className={`flex-shrink-0 mt-0.5 ${c.ic}`} />
      <div className={`flex-1 text-sm ${c.text}`}>{children}</div>
      {onClose && <button onClick={onClose} className={`flex-shrink-0 hover:opacity-70 bg-transparent border-0 cursor-pointer ${c.text}`}><Icon name="x" size={14} /></button>}
    </div>
  );
}
